"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyLocaleStringFormat = void 0;
/* eslint-disable @typescript-eslint/no-magic-numbers */
const country_code_1 = require("./country-code");
const locale_1 = require("./generated/locale");
__exportStar(require("./generated/locale"), exports);
const verifyLocaleStringFormat = (localeString) => {
    const fragments = localeString.split('-');
    if (fragments.length > 2) {
        return false;
    }
    const [lang, region] = fragments;
    const isLanguageValid = !!locale_1.LANGUAGES[lang];
    const isRegionValid = !region || !!country_code_1.IsoCountryCode2Char[region];
    return isLanguageValid && isRegionValid;
};
exports.verifyLocaleStringFormat = verifyLocaleStringFormat;
//# sourceMappingURL=locale.js.map